console.log('dog');

//
// JS
//
import './modules/layout.js';
import './modules/functions.js';
import './modules/hero.js';
import './modules/swiper.js';
import './modules/navigation.js';
import './modules/blocks.js';
import './modules/components.js';
import './modules/forms.js';
import './modules/accessibility.js';
import './modules/seo.js';

//
// Stylesheet
//
import '../sass/style.scss';

// In your JavaScript code (e.g., app.js)
// if (process.env.NODE_ENV === 'production') {
//     console.log('Webpack is running in production mode.');
// } else {
//     console.log('Webpack is running in development mode.');
// }

function mailinglist() {
	const mailingListForm = document.querySelector('.mailing-list-button');
	const popup = document.getElementById('mailing-popup');
	const closeBtn = document.querySelector('.popup__close');
	const overlay = document.querySelector('.popup__overlay');

	function showPopup(e) {
		e && e.preventDefault();
		document.body.classList.add('mailing-list-active');
		if (popup) popup.style.display = '';
	}

	function hidePopup(e) {
		e && e.preventDefault();
		document.body.classList.remove('mailing-list-active');
		if (popup) popup.style.display = 'none';
	}

	if (mailingListForm) mailingListForm.addEventListener('click', showPopup);
	if (closeBtn) closeBtn.addEventListener('click', hidePopup);
	if (overlay) overlay.addEventListener('click', hidePopup);
}

mailinglist();
